@if (!(isNavPopupOpen$ | async)) {
  @if (isVirtualTour || enabled) {
    <div class="btn-group btn-group-sm" role="group">
        @if (!transitioning) {
          <input id="dollhouse" type="checkbox" class="btn-check" name="btn-check" autocomplete="off"
              [checked]="enabled" (click)="toggle()">
        }
        <label class="btn btn-outline-light" for="dollhouse"
            [title]="enabled ? 'Exit Virtual Tour' : 'Virtual Tour'">
            <i [hidden]="enabled" class="fas fa-street-view"></i>
            <i [hidden]="!enabled" class="fa-solid fa-street-view"></i>
        </label>
    </div>
  }
}
